import * as React from 'react';

const Envelope24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M.998 7.021a3 3 0 0 1 3-3H20a3 3 0 0 1 3 3V17a3 3 0 0 1-3 3H3.998a3 3 0 0 1-3-3V7.02Zm18.96-1.5H4.024l6.86 5.62a1.75 1.75 0 0 0 2.218 0zM2.66 6.343a1.5 1.5 0 0 0-.162.678V17a1.5 1.5 0 0 0 1.5 1.5H20a1.5 1.5 0 0 0 1.5-1.5V7.02c0-.247-.06-.481-.167-.687l-7.28 5.967a3.25 3.25 0 0 1-4.12 0z"
  }
));
Envelope24.Size = 24;
Envelope24.Title = "Envelope";

export { Envelope24 as default };
